import { styled } from '@zeiss/beyond-online-react';
import type { ComponentPropsWithoutRef } from 'react';

const StyledRequiredField = styled.div`
  label::after {
    color: var(--color-global-text-info);
    content: ' *';
  }
`;

type RequiredFieldProps = ComponentPropsWithoutRef<'div'>;

/**
 * Adds a required field indicator (an asterisk *) to the label of its child input component.
 *
 * Usage:
 *
 * <RequiredField>
 *  <TextInput label="First Name" required />
 *  </RequiredField>
 */
export const RequiredField = ({ children, ...props }: RequiredFieldProps) => {
  return <StyledRequiredField {...props}>{children}</StyledRequiredField>;
};
